import React from 'react';

/**
 * BciLogo — official BCI brand mark.
 *
 * Use this everywhere a "logo" position appears (page headers, hero brand marks,
 * login pages, dashboard headers, verify cards). Replaces the generic Crown icon
 * that was previously used as a stand-in.
 *
 * Props:
 *   size       : pixel size of the logo (height + width, kept square; default 40)
 *   variant    : "dark-bg" (default, gold-on-dark) | "light-bg" (gold-on-light)
 *   withText   : if true, renders "BCI" + small "BITZ Club International" caption
 *                 next to the mark
 *   textColor  : tailwind text class for the wordmark (default "text-white")
 *   className  : extra classes on the wrapper
 *   alt        : accessible alt (default "BCI — BITZ Club International")
 */
const BciLogo = ({
  size = 40,
  variant = 'dark-bg',
  withText = false,
  textColor = 'text-white',
  className = '',
  alt = 'BCI — BITZ Club International',
  'data-testid': testId = 'bci-logo',
}) => {
  const src =
    variant === 'light-bg'
      ? '/brand/bci-logo-light-bg.png'
      : '/brand/bci-logo-dark-bg.png';

  return (
    <div className={`inline-flex items-center gap-3 ${className}`} data-testid={testId}>
      <img
        src={src}
        alt={alt}
        width={size}
        height={size}
        loading="eager"
        decoding="async"
        className="flex-shrink-0 object-contain"
        style={{ width: size, height: size }}
      />
      {withText && (
        <div className="flex flex-col leading-tight">
          <span
            className={`font-bold tracking-tight ${textColor}`}
            style={{ fontFamily: 'Playfair Display, serif', fontSize: size * 0.42 }}
          >
            BITZ Club
          </span>
          <span
            className="text-[#D4AF37]/85 uppercase"
            style={{
              fontFamily: 'Cinzel, serif',
              fontSize: Math.max(size * 0.2, 10),
              letterSpacing: '0.22em',
            }}
          >
            International
          </span>
        </div>
      )}
    </div>
  );
};

export default BciLogo;
